import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
import { State } from '@/helpers/entities/enums/v2/State';
// import { forEach } from 'lodash';
// import { EcommerceProductOptionInputModel } from '@/helpers/entities/models/EcommerceProductOptionInputModel';
export class EcommerceProductVariantInputModel extends BaseInputModel {
    constructor(payload = null) {
        super();
        if (payload) {
            Object.assign(this, {
                ...payload,
                state: State.idle,
                persistent: true,
            });
        }
        else {
            this.init();
        }
    }
    get name() {
        const variantName = [];
        if (this.productOptions.length >= 1) {
            this.productOptions.forEach((option) => {
                variantName.push(option.name);
            });
            // variantName.sort((a, b) => {
            //   return a!.localeCompare(b!);
            // })
        }
        return variantName.join(' - ');
    }
    markAsDeleted() {
        this.state = State.deleted;
    }
    init() {
        this.uuid = null;
        this.published = true;
        this.stockQuantity = 0;
        this.productOptions = [];
        this.state = State.new;
        this.price = 0;
        this.boughtAndReservedCount = 0;
        this.limited = false;
        this.digitalProduct = false;
    }
}
